module.exports = __webpack_public_path__ + "img/E804E8_B504B5_CC04CC_FC33FC-256px.ca03ef1c.png";